// Components==============
import { faPlay } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import CircleButton from 'components/UI/CircleButton/CircleButton';
import React, { useEffect, useState } from 'react';
import { useAudio } from 'utilities/useAudio';
import './Audio.module.scss';
import Button from 'components/UI/Button/Button';
import { useLocation } from 'react-router';
import { getDeviceInfo } from 'utilities/getDeviceInfo';
import { useDispatch, useSelector } from 'react-redux';
import storeUserFeedback from 'actions/userFeedback/store';
import { faWaveform } from '@fortawesome/pro-regular-svg-icons';
// =========================

type AnswersType = {
    generatedAudioWorked: null | boolean;
    mp3InPlatformWorked: null | boolean;
    mp3InNewTabWorked: null | boolean;
};

export default function Audio() {
    const [step, setStep] = useState(1);
    const [audioPlaying, setAudioPlaying] = useState(false);
    const [answers, setAnswers] = useState<AnswersType>({
        generatedAudioWorked: null,
        mp3InPlatformWorked: null,
        mp3InNewTabWorked: null,
    });
    const { play, duration } = useAudio({
        text: 'De audio in Spiek Digitaal werkt goed.',
    });

    const audioMp3 = useAudio({
        audioFile: '/audio/test-page/1.-Geluidstest.mp3',
    });

    const location = useLocation();
    const deviceInfo = getDeviceInfo();
    const dispatch = useDispatch();
    const user = useSelector((state) => {
        if (!state.authentication?.user) return {};
        const { id, name, role, treatments } = state.authentication?.user;

        const activeTreatment = treatments.find((t) => t?.pivot?.open)?.id || 0;

        return { id, name, role, activeTreatment, treatments };
    });

    function playAudio() {
        if (!audioPlaying) {
            play();
            setAudioPlaying(true);

            const timeout = setTimeout(() => {
                setStep((prev) => prev + 1);
                clearTimeout(timeout);
                setAudioPlaying(false);
            }, (duration || 1500) * 1.5);
        }
    }

    function playAudioMp3() {
        if (!audioPlaying) {
            audioMp3.play();
            setAudioPlaying(true);

            const timeout = setTimeout(() => {
                setStep((prev) => prev + 1);
                clearTimeout(timeout);
                setAudioPlaying(false);
            }, (duration || 1500) * 1.5);
        }
    }

    function goToMP3() {
        const mp3Url = '/audio/test-page/1.-Geluidstest.mp3';
        window.open(mp3Url, '_blank');
        setStep((prev) => prev + 1);
    }

    const sendAudioFeedback = () => {
        const parsedLocation = 'testpagina-audio';

        console.log(answers);

        const data = {
            description: `Audio werkte niet. \n \n
            Gegenereerd geluid vanuit spiek: ${
                answers.generatedAudioWorked === null
                    ? '____'
                    : answers.generatedAudioWorked
                    ? 'Wel geluid'
                    : 'Geen geluid'
            } \n
            Mp3 van spiek via UseAudio: ${
                answers.mp3InPlatformWorked === null
                    ? '____'
                    : answers.mp3InPlatformWorked
                    ? 'Wel geluid'
                    : 'Geen geluid'
            }
            \n
            Mp3 van spiek op nieuw tablad: ${
                answers.mp3InNewTabWorked === null
                    ? '____'
                    : answers.mp3InNewTabWorked
                    ? 'Wel geluid'
                    : 'Geen geluid'
            }`,
            url: location.pathname,
            location: parsedLocation,
            metadata: JSON.stringify(deviceInfo),
            user_meta: JSON.stringify(user),
            problemType: 'testpage-audio',
        };

        dispatch(storeUserFeedback(data))
            .then((e) => {
                alert('Melding verstuurd!');
            })
            .catch((e) => {
                console.error(e);
                alert('Het is niet gelukt de melding op te slaan.');
            });
    };

    function goToEndScreen(audioWorked: boolean) {
        if (audioWorked) {
            setStep(7);
        } else {
            setStep(8);
        }
    }

    useEffect(() => {
        if (step === 7 || step === 8) {
            sendAudioFeedback();
        }
    }, [step]);

    return (
        <div styleName="wrapper">
            {step === 1 && (
                <CircleButton onClick={playAudio}>
                    <FontAwesomeIcon
                        icon={audioPlaying ? faWaveform : faPlay}
                    />
                </CircleButton>
            )}
            {step === 2 && (
                <div styleName="block">
                    <h3>Hoorde je geluid?</h3>
                    <div styleName="row">
                        <Button
                            onClick={() => {
                                setAnswers((prev) => ({
                                    ...prev,
                                    generatedAudioWorked: true,
                                }));
                                goToEndScreen(true);
                            }}
                        >
                            Ja
                        </Button>
                        <Button
                            onClick={() => {
                                setAnswers((prev) => ({
                                    ...prev,
                                    generatedAudioWorked: false,
                                }));
                                setStep((prev) => prev + 1);
                            }}
                            grey
                        >
                            Nee
                        </Button>
                    </div>
                </div>
            )}

            {step === 3 && (
                <CircleButton onClick={playAudioMp3}>
                    <FontAwesomeIcon
                        icon={audioPlaying ? faWaveform : faPlay}
                    />
                </CircleButton>
            )}
            {step === 4 && (
                <div styleName="block">
                    <h3>Hoorde je geluid?</h3>
                    <div styleName="row">
                        <Button
                            onClick={() => {
                                setAnswers((prev) => ({
                                    ...prev,
                                    mp3InPlatformWorked: true,
                                }));
                                goToEndScreen(true);
                            }}
                        >
                            Ja
                        </Button>
                        <Button
                            onClick={() => {
                                setAnswers((prev) => ({
                                    ...prev,
                                    mp3InPlatformWorked: false,
                                }));
                                setStep((prev) => prev + 1);
                            }}
                            grey
                        >
                            Nee
                        </Button>
                    </div>
                </div>
            )}

            {step === 5 && (
                <div styleName="block">
                    <h3>
                        Probeer eens of het geluid werkt op{' '}
                        <span onClick={goToMP3}>deze link</span>
                    </h3>
                </div>
            )}
            {step === 6 && (
                <div styleName="block">
                    <h3>Hoorde je geluid in het geopende tabblad?</h3>
                    <div styleName="row">
                        <Button
                            onClick={() => {
                                setAnswers((prev) => ({
                                    ...prev,
                                    mp3InNewTabWorked: true,
                                }));
                                goToEndScreen(true);
                            }}
                        >
                            Ja
                        </Button>
                        <Button
                            onClick={() => {
                                setAnswers((prev) => ({
                                    ...prev,
                                    mp3InNewTabWorked: false,
                                }));
                                goToEndScreen(false);
                            }}
                            grey
                        >
                            Nee
                        </Button>
                    </div>
                </div>
            )}
            {step === 7 && (
                <div styleName="block">
                    <h3>
                        Je geluid lijkt het in sommige omstandigheden te doen
                    </h3>
                    <p>
                        We hebben je antwoorden ontvangen en gaan er naar
                        kijken.
                    </p>
                </div>
            )}
            {step === 8 && (
                <div styleName="block">
                    <h3>Je geluid lijkt het inderdaad niet te doen</h3>
                    <p>
                        We hebben je antwoorden ontvangen en gaan er naar
                        kijken.
                    </p>
                </div>
            )}
        </div>
    );
}
